module.exports = __webpack_public_path__ + "img/dots-horz.a4fdf06a.svg";